import Base from "../base/Base";
import Pager from "../base/Pager";
import Topic from "../topic/Topic";
import TopicMenu from "../topic/TopicMenu";
import Vue from "vue";
import DefaultTheme from "../../../lobby/view/theme/DefaultTheme.vue";
import HomeTheme from "../../../lobby/view/theme/HomeTheme.vue";
import {themeList} from "../../../common/store/Themes";
import NotFoundView from "../../../lobby/view/404.vue";

import LbIndexView from "../../../lobby/view/scenery/index/SceneryIndex.vue";
import ArticleListView from "../../../lobby/view/article/List.vue";
import ArticleDetailView from "../../../lobby/view/article/Detail.vue";
import ArticleSearchView from "../../../lobby/view/article/Search.vue";
import VideoDetailView from "../../../lobby/view/video/Detail.vue";
import PersonDetailView from "../../../lobby/view/person/Detail.vue";

//该类专门统一管理网站中所有的topic.
export default function TopicManager(id = null, name = null, description = null) {

	//extend Base's Attributes.
	Base.call(this, arguments);

	this.pager = new Pager(Topic, 50);
	this.topics = [];

}


//extend Base's methods.
TopicManager.prototype = new Base();
TopicManager.prototype.constructor = TopicManager;

//We use this method to get the full js Object.
TopicManager.prototype.render = function (obj) {

	Base.prototype.render.call(this, obj);

}


TopicManager.prototype.httpInit = function () {
	let that = this;
	this.loading = true;

	this.pager.httpFastPage(function () {
		that.loading = false;
		that.topics = that.pager.topics;
		that.initRoutes();
	}, function () {
		that.loading = false;


	});

}

//获取topic的component.
TopicManager.prototype.getTopicComponent = function (topic) {
	if (topic.type === Topic.prototype.Type.ARTICLE) {
		return ArticleDetailView;
	}
	if (topic.type === Topic.prototype.Type.PERSON) {
		return PersonDetailView;
	} else if (topic.type === Topic.prototype.Type.SCENERY) {
		return topic.scenery.component;
	} else {
		console.error("Topic类型错误！！");
		return null;
	}
}
TopicManager.prototype.getTopicMeta = function (topic) {
	if (topic.type === Topic.prototype.Type.ARTICLE) {
		return {
			title: topic.name,
			articleId: topic.article.id,
			topic: topic
		};
	} else if (topic.type === Topic.prototype.Type.SCENERY) {
		return {
			title: topic.name,
			topic: topic
		};
	} else {
		console.error("Topic类型错误！！");
		return null;
	}
}


//获取menu的component.
TopicManager.prototype.getMenuComponent = function (menu) {
	if (menu.type === TopicMenu.prototype.Type.ARTICLE) {
		return ArticleDetailView;
	} else if (menu.type === TopicMenu.prototype.Type.PERSON) {
		return PersonDetailView;
	} else if (menu.type === TopicMenu.prototype.Type.SCENERY) {
		return menu.scenery.component;
	} else {
		console.error("TopicMenu类型错误！！");
		return null;
	}
}

TopicManager.prototype.getMenuMeta = function (menu) {

	if (menu.type === TopicMenu.prototype.Type.ARTICLE) {
		return {
			title: menu.parentTopic.name,
			articleId: menu.article.id,
			topicMenu: menu,
			topic: menu.parentTopic
		};
	} else if (menu.type === TopicMenu.prototype.Type.PERSON) {
		return {
			title: menu.parentTopic.name,
			personId: menu.person.id,
			topicMenu: menu,
			topic: menu.parentTopic
		};
	} else if (menu.type === TopicMenu.prototype.Type.SCENERY) {
		return {
			title: menu.parentTopic.name,
			topicMenu: menu,
			topic: menu.parentTopic
		};
	} else {
		console.error("TopicMenu类型错误！！");
		return null;
	}
}


TopicManager.prototype.initRoutes = function () {

	let that = this;


	let topicRoutes = [];
	let homeTopic = null;

	//添加所有框架预览的效果图。
	//添加一组用于预览的topic数据。
	let topics = this.topics;

	for (let i = 0; i < themeList.length; i++) {
		let theme = themeList[i];
		let topic = new Topic();
		topic.render(theme.topicJson);
		topic.location = theme.getPreviewLocation();
		topic.theme = theme;
		topic.poster = null;
		topic.name = theme.name;
		topics.push(topic);
	}


	//添加所有从后端获取到的topic.
	for (let i = 0; i < this.topics.length; i++) {
		let topic = this.topics[i];

		if (topic.id === 1) {
			homeTopic = topic;
		}

		let topicComponent = topic.theme.component;
		if (!topicComponent) {
			console.error("没有选择Theme.");
			topicComponent = DefaultTheme;
		} else {
		}


		if (topic.location) {
			let subRoutes = [];
			let topicRoute = {
				path: "/" + topic.location,
				component: topicComponent,
				children: subRoutes
			};

			//添加首页。
			subRoutes.push({
				path: '',
				name: "topic_" + topic.location,
				component: that.getTopicComponent(topic),
				meta: that.getTopicMeta(topic)
			});

			//添加各个菜单具体。
			for (let j = 0; j < topic.menus.length; j++) {
				let topicFirstMenu = topic.menus[j];

				if (topicFirstMenu.type === TopicMenu.prototype.Type.ARTICLE || topicFirstMenu.type === TopicMenu.prototype.Type.PERSON || topicFirstMenu.type === TopicMenu.prototype.Type.SCENERY) {
					subRoutes.push({
						path: topicFirstMenu.location,
						name: "topic_" + topic.location + "_" + topicFirstMenu.location,
						component: that.getMenuComponent(topicFirstMenu),
						meta: that.getMenuMeta(topicFirstMenu)
					});
				}

				if (topicFirstMenu.isParent()) {
					for (let k = 0; k < topicFirstMenu.menus.length; k++) {
						let topicSecondMenu = topicFirstMenu.menus[k];

						//文章，人物，自定义页面时给加上路由。
						if (topicSecondMenu.type === TopicMenu.prototype.Type.ARTICLE || topicSecondMenu.type === TopicMenu.prototype.Type.PERSON || topicSecondMenu.type === TopicMenu.prototype.Type.SCENERY) {
							subRoutes.push({
								path: topicFirstMenu.location + "/" + topicSecondMenu.location,
								name: "topic_" + topic.location + "_" + topicFirstMenu.location + "_" + topicSecondMenu.location,
								component: that.getMenuComponent(topicSecondMenu),
								meta: that.getMenuMeta(topicSecondMenu)
							});

						}
					}
				}


			}


			//添加预设的一些页面。

			//文章列表。
			subRoutes.push({
				//NEWS
				path: 'article/:type',
				name: "topic_" + topic.location + "_articles_type",
				component: ArticleListView,
				meta: {
					topic: topic
				}
			});
			//文章详情
			subRoutes.push({
				path: 'article/detail/:id',
				name: "topic_" + topic.location + "_article_detail",
				component: ArticleDetailView,
				meta: {
					topic: topic
				}
			});
			//视频详情
			subRoutes.push({
				path: 'video/detail/:id',
				name: "topic_" + topic.location + "_video_detail",
				component: VideoDetailView,
				meta: {
					topic: topic
				}
			});
			//教师团队
			subRoutes.push({
				path: 'person/detail/:id',
				name: "topic_" + topic.location + "_person_detail",
				component: PersonDetailView,
				meta: {
					topic: topic
				}
			});
			//搜索页面
			subRoutes.push({
				path: 'article/search',
				name: "topic_" + topic.location + "_article_search",
				component: ArticleSearchView,
				meta: {
					topic: topic
				}
			});

			//404页面
			subRoutes.push({
				path: '*',
				name: "topic_" + topic.location + "_404",
				component: NotFoundView,
				meta: {
					topic: topic
				}
			});
			topicRoutes.push(topicRoute);
		}
	}

	//添加一些预设页面。
	let preDefineRouter = {
		path: '/',
		component: HomeTheme,
		children: [
			{
				path: '',
				name: "default_index",
				component: LbIndexView,
				meta: {
					topic: homeTopic
				}
			},

			//404页面
			{
				path: '*',
				name: "default_404",
				component: NotFoundView,
				meta: {
					topic: homeTopic
				}
			}
		]
	};
	topicRoutes.push(preDefineRouter);
	Vue.router.addRoutes(topicRoutes);
}




// WEBPACK FOOTER //
// ./src/common/model/topic/TopicManager.js